import styled from "styled-components";

const HeaderHeader = styled.header`
  width: 100%;
  height: 113px;
  margin-bottom: 153px;
  z-index: 99;

  @media only screen and (max-width : 1023px) {
    height: auto;
    margin-bottom: 40px;
  }
`;

const HeaderContainer = styled.div`
  max-width: 1320px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media only screen and (max-width : 1365px) {
    padding: 0 20px;
  }

  @media only screen and (max-width : 1023px) {
    flex-wrap: wrap;
  }
`

const HeaderLogotDiv = styled.div`
  width: fit-content;
  height: fit-content;
  margin-top: 61px;

  h1 {
    font-size: 0;
  }

  @media only screen and (max-width : 1023px) {
    margin-top: 15px;
    order: 0;
  }
`

const HeaderTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 495px;
  width: 100%;
  height: auto;
  margin-top: 48px;

  strong {
    font-size: 40px;
    line-height: 44px;
    font-weight: 400;
    color: #FFFFFF;
    font-family: "Eina01-Bold";
    text-transform: uppercase;
    text-align: left;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    color: #FFFFFF;
    font-family: "Eina01-Medium";
    margin: 0;
  }

  @media only screen and (max-width : 1023px) {
    max-width: 100%;
    margin-top: 40px;
    order: 2;
    
    strong {
      font-size: 30px;
      line-height: 33px;
    }
  }
`;

const HeaderLinktDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 20px;

  a {
    font-size: 11px;
    line-height: 16px;
    font-weight: 400;
    color: #D4FC00;
    font-family: "Eina01-Bold";
    text-transform: uppercase;
    text-decoration: none;
    transition: all ease-in-out 0.3s;

    &:hover {
      color: #FFFFFF;
    }
  }

  @media only screen and (max-width : 1023px) {
    margin-top: 15px;
    order: 1;
    
    a {
      max-width: 128px;
      text-align: right;
    }
  }
`

export {
  HeaderHeader,
  HeaderContainer,
  HeaderLogotDiv,
  HeaderTextDiv,
  HeaderLinktDiv,
}